<img [src] = "imageSrc" class = "background-image" />
<img src = "assets/images/play-icon-with-shadow.webp" class = "play-button" />